import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import MCTopView from '@common/images/microcentrifuge_topview_lid_closed.svg';
import {Image} from '@learningblocks/shared-components/lib/Image';

import './style.scss';

export function LidClosed(props) {
  const {t} = useTranslation();

  return (
    <Image
      className='mc_equipment_topview--closed_image'
      src={MCTopView}
      alt='microcentrifuge top view lid closed'
    />
  );
}

LidClosed.propTypes = {
  /**
   * callback for when lid is clicked
   */
  toggleLid: PropTypes.func,
};
